module.exports = __webpack_public_path__ + "img/matthieu_s.0d836052.png";